import { useTournamentState } from './TournamentContext.jsx';
import { UI_TEXT } from './utils/constants.js';
import './RankingScreen.css';

/**
 * RankingScreen - Display tournament rankings
 * @param {Object} props
 * @param {Function} props.onBack - Callback to return to result screen
 * @param {string} props.language - Language code ('ko' or 'en')
 */
export default function RankingScreen({ onBack, language = 'ko' }) {
  const state = useTournamentState();
  const text = UI_TEXT[language] || UI_TEXT.ko;

  // campaignData에서 entries 추출
  const entries = state.campaignData?.entries || [];

  // entries를 wins 기준으로 정렬 (이미 서버에서 정렬되어 옴)
  const rankings = entries
    .sort((a, b) => b.wins - a.wins)
    .map((item, index) => ({
      rank: index + 1,
      ...item
    }));

  // 최대 wins 값 (bar 계산용)
  const maxWins = rankings.length > 0 ? rankings[0].wins : 1;

  return (
    <div className="ranking-screen">
      <div className="ranking-screen__content">
        <h1 className="ranking-screen__title">{text.rankingsTitle}</h1>

        <div className="ranking-screen__list">
          {rankings.length > 0 ? (
            <div className="ranking-table">
              <div className="ranking-table__header">
                <div className="ranking-table__cell ranking-table__cell--rank">{text.rankingRank}</div>
                <div className="ranking-table__cell ranking-table__cell--image"></div>
                <div className="ranking-table__cell ranking-table__cell--name">{text.rankingName}</div>
                <div className="ranking-table__cell ranking-table__cell--bar">{text.rankingWins}</div>
              </div>

              {rankings.map((item) => {
                const displayName = language === 'en' ? item.nameEn || item.name : item.name;
                const barWidth = (item.wins / maxWins) * 100;

                return (
                  <div key={item.id} className="ranking-table__row">
                    <div className="ranking-table__cell ranking-table__cell--rank">
                      <span className={`ranking-number ${item.rank <= 3 ? 'ranking-number--top' : ''}`}>
                        {item.rank}
                      </span>
                    </div>

                    <div className="ranking-table__cell ranking-table__cell--image">
                      <img
                        src={item.img}
                        alt={displayName}
                        className="ranking-image"
                      />
                    </div>

                    <div className="ranking-table__cell ranking-table__cell--name">
                      <span className="ranking-name">{displayName}</span>
                    </div>

                    <div className="ranking-table__cell ranking-table__cell--bar">
                      <div className="ranking-bar-wrapper">
                        <div
                          className="ranking-bar"
                          style={{
                            width: `${barWidth}%`,
                            background: state.themeColor
                          }}
                        />
                        <span className="ranking-wins">{item.wins}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="ranking-screen__placeholder">
              랭킹 데이터를 불러오는 중...
            </p>
          )}
        </div>

        <div className="ranking-screen__actions">
          <button
            className="ranking-screen__back-button"
            style={{
              background: state.themeColor
            }}
            onClick={onBack}
            type="button"
          >
            {text.backToResult}
          </button>
        </div>
      </div>
    </div>
  );
}